import React from "react";
import {
  ShieldCheck, ScrollText, Headset, BadgeCheck, Users, Wrench,
  FileCheck2, BookOpen, Plane, MessagesSquare, RefreshCcw, Handshake,
} from "lucide-react";

/* Map content-string icon names → lucide components, so the shared
   content module can stay JSX-free. */
const MAP = {
  shield: ShieldCheck, scroll: ScrollText, headset: Headset, badge: BadgeCheck,
  users: Users, wrench: Wrench, filecheck: FileCheck2, book: BookOpen,
  plane: Plane, message: MessagesSquare, refresh: RefreshCcw, handshake: Handshake,
};

export function Icon({ name, ...props }) {
  const C = MAP[name] || ShieldCheck;
  return <C {...props} />;
}

export default Icon;
